import { N0 } from '@atlaskit/theme/colors';
import React from 'react';
import { allAppsWidth } from '../../Common/ReportsTableSummary';
import ReportSummaryOverview from '../../Common/ReportSummaryOverview';
import { getChartLinesDetails, getReportColumnsForOverviewSeries } from '../CloudChurnOrRenewals.utils';
const getColorRateMapping = (columnKey, canUsePatternLines, reportName) => {
  if (columnKey.toLowerCase().includes('monthly')) return getChartLinesDetails(canUsePatternLines, reportName)[0].color;
  if (columnKey.toLowerCase().includes('annual')) return getChartLinesDetails(canUsePatternLines, reportName)[1].color;
  return N0;
};
export default function CloudChurnOrRenewalsSummary(props) {
  const {
    datasets,
    reportName,
    period
  } = props;
  const reportMeta = {
    reportName,
    period
  };
  const reportColumns = getReportColumnsForOverviewSeries(datasets, reportName);
  const summary = reportColumns.map(column => ({
    head: column.key,
    color: getColorRateMapping(column.key, props.canUsePatternLines, reportName),
    content: /*#__PURE__*/React.createElement("div", null, column.content),
    width: "".concat((100 - allAppsWidth) / reportColumns.length, "%")
  }));
  return /*#__PURE__*/React.createElement(ReportSummaryOverview, {
    reportMeta: reportMeta,
    summary: summary
  });
}